"use strict";
// _partialFile.js

// アコーディオン（details/summary。data-accordion-item / -trigger / -panel の3点で動く）
const IS_OPENED_CLASS = "is-opened";

// transition の実時間（0s のときも閉じ切れるように computed から測る）
const getAccordionDuration = (panel) => parseFloat(getComputedStyle(panel).transitionDuration) * 1000 || 0;

// パネルを開く（open を立ててから実測した高さへアニメーション）
const openAccordionPanel = (details, panel) => {
  details.open = true;
  details.classList.add(IS_OPENED_CLASS);
  panel.style.height = "0";
  // 高さを再計算
  void panel.offsetHeight;
  panel.style.height = `${panel.scrollHeight}px`;
};

// パネルを閉じる（auto を実測値に戻してから 0 へ。open は閉じ切ってから外す）
const closeAccordionPanel = (details, panel) => {
  panel.style.height = `${panel.scrollHeight}px`;
  // 高さを再計算
  void panel.offsetHeight;
  details.classList.remove(IS_OPENED_CLASS);
  panel.style.height = "0";
};

// 開き切ったら中身の増減に追従させ、閉じ切ってから open を外す
const settleAccordionPanel = (details, panel) => {
  if (details.classList.contains(IS_OPENED_CLASS)) {
    panel.style.height = "auto";
  } else {
    details.open = false;
  }
};

// 同じグループ内の他アコーディオンを閉じる
const closeOtherAccordionsInGroup = (currentDetails) => {
  const group = currentDetails.closest("[data-accordion-group]");

  if (!group) return;

  group.querySelectorAll("[data-accordion-item]").forEach((details) => {
    if (details === currentDetails || !details.classList.contains(IS_OPENED_CLASS)) return;

    const otherPanel = details.querySelector("[data-accordion-panel]");

    if (!otherPanel) return;

    closeAccordionPanel(details, otherPanel);
    setTimeout(() => settleAccordionPanel(details, otherPanel), getAccordionDuration(otherPanel));
  });
};

const setUpAccordion = () => {
  const items = document.querySelectorAll("[data-accordion-item]");

  if (!items.length) return;

  items.forEach((details) => {
    const trigger = details.querySelector("[data-accordion-trigger]");
    const panel = details.querySelector("[data-accordion-panel]");

    if (!trigger || !panel) return;

    // 初期表示で開いているものはクラスと高さを同期しておく
    if (details.open) {
      details.classList.add(IS_OPENED_CLASS);
      panel.style.height = "auto";
    }

    let settleTimer = 0;

    // 既定のトグルを止め、アニメーションつきで開閉する
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      clearTimeout(settleTimer);

      if (details.classList.contains(IS_OPENED_CLASS)) {
        closeAccordionPanel(details, panel);
      } else {
        closeOtherAccordionsInGroup(details);
        openAccordionPanel(details, panel);
      }

      settleTimer = setTimeout(() => settleAccordionPanel(details, panel), getAccordionDuration(panel));
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});
